module.exports = __webpack_public_path__ + "static/LovingDoodle-85ffb35d034544bc5c475b21eb125a54.png";